import { Injectable } from '@angular/core';
import { fromEvent, Observable } from 'rxjs';
import { map, distinctUntilChanged, startWith } from 'rxjs/operators';

export interface IBrowserWindowSize {
  width: number;
  height: number;
}

interface IBrowserWindowEvent {
  target: Window;
}

@Injectable()
export class BrowserResizeService {
  readonly windowResize$: Observable<IBrowserWindowSize> = fromEvent<IBrowserWindowEvent>(window, 'resize').pipe(
    map(({ target }: IBrowserWindowEvent) => this.getWindowsSize(target))
  );

  readonly windowHorizontalResize$: Observable<number> = this.windowResize$.pipe(
    map((size: IBrowserWindowSize) => size.width),
    distinctUntilChanged()
  );

  readonly windowVerticalResize$: Observable<number> = this.windowResize$.pipe(
    map((size: IBrowserWindowSize) => size.height),
    distinctUntilChanged()
  );

  readonly windowSize$: Observable<IBrowserWindowSize> = this.windowResize$.pipe(
    startWith(this.getWindowsSize(window))
  );

  private getWindowsSize(window: Window): IBrowserWindowSize {
    return { width: window.innerWidth, height: window.innerHeight };
  }
}
